import { Link } from 'react-router-dom';
import '../../styles/auth-status.css';

const buttonVariantClass = {
  primary: 'tk-button--primary',
  secondary: 'tk-button--secondary',
  ghost: 'tk-button--tertiary',
};

function AuthAction({ action }) {
  const variant = action.variant || 'secondary';
  const actionClassName = `auth-status__action tk-button ${
    buttonVariantClass[variant] || buttonVariantClass.secondary
  }`;

  if (action.external) {
    return (
      <a
        className={actionClassName}
        href={action.href}
      >
        <span>{action.label}</span>
        {action.icon}
      </a>
    );
  }

  return (
    <Link
      className={actionClassName}
      to={action.href}
    >
      <span>{action.label}</span>
      {action.icon}
    </Link>
  );
}

export default function AuthStatusLayout({
  tone = 'neutral',
  eyebrow,
  title,
  body,
  note,
  statusLabel,
  icon,
  actions = [],
  children,
}) {
  return (
    <main className={`auth-status auth-status--${tone}`}>
      <div className="auth-status__ambient auth-status__ambient--primary" />
      <div className="auth-status__ambient auth-status__ambient--secondary" />

      <div className="auth-status__frame">
        <Link to="/" className="auth-status__brand">
          TECNIQ
        </Link>

        <section className="auth-status__card ghost-outline">
          <div className="auth-status__badge">
            <span className="auth-status__badge-icon">{icon}</span>
            <span>{statusLabel}</span>
          </div>
          {eyebrow ? <p className="auth-status__eyebrow">{eyebrow}</p> : null}
          <h1 className="auth-status__title">{title}</h1>
          <p className="auth-status__body">{body}</p>

          {note ? <p className="auth-status__note">{note}</p> : null}
          {children ? <div className="auth-status__content">{children}</div> : null}

          {actions.length > 0 ? (
            <div className="auth-status__actions">
              {actions.map((action) => (
                <AuthAction key={`${action.label}-${action.href}`} action={action} />
              ))}
            </div>
          ) : null}
        </section>
      </div>
    </main>
  );
}
